/**
 * 访问资源国际化
 * date：2022 03 07
 */
 export default {
    resource:{
    in:'In',
    menu:'Menu',
    menuMsg:'Menu Info',
    name:'Instance Name',
    nameZh:'Chinese Name',
    nameEn:'English Name',
    nameZhNotEmpty:'Chinese Name is required.',
    nameEnNotEmpty:'English Name is required.',
    code:'ID/SN',
    enable:'Enable',
    visualRole:'Visible Roles',
    peerMenu:'Sibling Menu',
    subMenu:'Submenu',
    add:'New',
    refresh:'Auto Refresh Time',
    intry:'Entry',
    func:"Function",
    funcCode:'Function Code',
    optare:'Actions',
    confirm:'Confirm' ,
    edit:'Edit',
    cancel:'Cancel',
    delete:'Delete',
    funcCodeNotEmtry:'Function Code is required.',
    noData:'No Data Available',
    icon:'Icon',
    iconNot:'Invalid Icon',
    fillManuaiiy:'Manual Entry',
    nameNotEmpty:'Name is required.',
    codeNotEmpty:'ID/SN is required.',
    iconNotEmpty:'Icon is required.',
    yes:'Confirm',
    no:'No',
    allVisible:'All Visible',
    adminVisible:'Admin Visible',
    systemVisible:'System-wide Visibile',
    extraCode:"Extra Code",


    // V8: FunctionDialog popup
    functionDetail:'Function Detail',
    addFunction:'Add Function',
    editFunction:'Edit Function',
    urlList:'URL List',
    url:'URL',
    method:'Method',
    pathParam:'Path Params',
    addUrl:'Add URL',
    removeUrl:'Remove',
    selectUrl:'Select URL',
    urlNotEmpty:'URL is required.',
    urlAlreadyExists:'This URL has already been added.',
    urlCount:'URL Count',
    selectUrlPlaceholder:'Please select URLs to associate',
    noUrlSelected:'No URL added yet',

    code_407:"Name already exists.",
    code_408:"ID/SN already exists.",
    drag_sort_tip:'Drag menu nodes to reorder',
    sort_saved:'Sort order saved',
    sort_save_failed:'Failed to save sort order, reverted',
    }
}
